import React from "react";
import { AlertTriangle } from "lucide-react";

const DistributorErrorsTooltip = ({ distributorErrors = [] }) => {
  if (distributorErrors.length === 0) return null;

  return (
    <div className="relative group">
      <AlertTriangle className="w-4 h-4 text-amber-500 cursor-pointer" />
      <div className="absolute right-0 bottom-full mb-1 z-20 hidden group-hover:block w-64 bg-gray-900 text-white text-xs rounded-lg p-2.5 shadow-xl">
        <p className="font-semibold mb-1.5 text-amber-300">Distributor Errors:</p>
        {distributorErrors.map((err, i) => (
          <div
            key={i}
            className={i > 0 ? "mt-1.5 pt-1.5 border-t border-gray-700" : ""}
          >
            <span className="font-medium text-amber-200">{err.distributor}:</span>
            <span className="ml-1 text-gray-300">{err.error_message}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DistributorErrorsTooltip;
